import axios from 'axios';
import qs from 'qs';
import { ref } from 'vue';
import { error } from '~/utils';

const API_URL = import.meta.env.VITE_API_URL;

export function useObterTotalCompromissosEmAndamentoPorDiaNoMes() {
  const status = ref('loading');
  const err = ref(null);
  const response = ref(null);

  async function obter(query) {
    status.value = 'loading';
    try {
      const r = await axios.get(`${API_URL}/compromissos/obter-total-compromissos-em-andamento-por-dia-no-mes`, {
        params: query,
        paramsSerializer: params => qs.stringify(params),
        timeout: 120000,
        getAccessToken: true,
      });
      status.value = 'success';
      response.value = r.data;
    }
    catch (e) {
      status.value = 'error';
      err.value = error(e);
    }
  }

  return {
    status,
    err,
    response,
    obter,
  };
}
